@if (data.showCloseIcon === true) {
  <div class="close-icon" (click)="closeDialog()">
    <fa-icon [icon]="['fas', 'times']"></fa-icon>
  </div>
}
@if (data.title || data.message) {
  <div class="title-wrapper">
    <!-- If `showIcon` is not passed as a boolean, the default 'exclamation-triangle' icon will still be shown. -->
    @if (data.showIcon !== false) {
      <fa-icon [icon]="['fas', 'exclamation-triangle']"></fa-icon>
    }
    @if (data.title) {
      <p class="title">
        {{ data.title }}
      </p>
    } @else {
      <p class="message">
        {{ data.message }}
      </p>
    }
  </div>
}

@if (data.otherInfo?.note) {
  <p class="note">Note: {{ data.otherInfo?.note }}</p>
}

@if (data.otherInfo) {
  <div class="other-info">
    <p class="message">{{ data.otherInfo.header }}</p>
    @if (data.otherInfo.data) {
      <ul>
        @for (data of data.otherInfo.data; track data) {
          <li>{{ data }}</li>
        }
      </ul>
    }
    @if (data.otherInfo.caption && data.otherInfo.data && data.otherInfo.data.length > 0) {
      <span
        class="caption-text"
        >
        {{ data.otherInfo.caption }}
      </span>
    }
  </div>
}
@if (data.constructionCostInfo && data.constructionCostInfo.header) {
  <div
    class="other-info construction-cost"
    >
    <p class="message red">
      {{ data.constructionCostInfo.header }}
    </p>
    <div class="input-fields">
      <label>Materials Cost:</label>
      <input
        matInput
        numberInput
        [mask]="moneyMask"
        [prefix]="maskConfig.currency"
        [thousandSeparator]="maskConfig.thousandSeparator"
        [separatorLimit]="maskConfig.separatorLimit"
        [(ngModel)]="data.constructionCostInfo.materialsCost"
        decimalMarker="."
        />
    </div>
    <div class="input-fields">
      <label>Labour and Other Cost:</label>
      <input
        matInput
        numberInput
        [mask]="moneyMask"
        [prefix]="maskConfig.currency"
        [thousandSeparator]="maskConfig.thousandSeparator"
        [separatorLimit]="maskConfig.separatorLimit"
        [(ngModel)]="data.constructionCostInfo.laborAndOtherCost"
        decimalMarker="."
        />
    </div>
  </div>
}

<div class="button-group">
  @if (!data.hideCancelButton) {
    <page-button
      [config]="{ rank: 'secondary' }"
      (clicked)="closeDialog()"
      ngClass="cancel-button"
      >
      {{ data.cancelBtnText || 'Cancel' }}
    </page-button>
  }
  <page-button
    [config]="{ rank: 'primary' }"
    (clicked)="
      data.constructionCostInfo
        ? onContinue(
            data.constructionCostInfo.materialsCost,
            data.constructionCostInfo.laborAndOtherCost
          )
        : onContinue()
    "
    >
    {{ data.continueBtnText || 'Continue' }}
  </page-button>
</div>